import React from 'react';
import '@panwds/icons';
import '@panwds/react-ui';
import { useTableInstance } from '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import 'uuid';
import { ConnectedPaginator } from '../Paginator/ConnectedPaginator.esm.js';
import { ConnectedResultsSummary } from '../ResultsSummary/ConnectedResultsSummary.esm.js';
import 'react-intl';
import { TableLayout } from './TableLayout.esm.js';

/**
 * Helps layout controls and pagination of a table.
 * Will handle spacing and add a border to the Table.
 */
function ConnectedTableLayout({ isBackgroundFetching: deprecatedIsBackgroundFetching, dataMetrics, dataTestId, menuStyle, rowName, paginator = (React.createElement(ConnectedPaginator, { rowName: rowName, menuStyle: menuStyle, dataTestId: dataTestId })), resultsSummary, overflow = false, ...rest }) {
    const { enablePagination, isBackgroundFetching: instanceIsBackgroundFetching, manualPagination, } = useTableInstance();
    const paginationEnabled = enablePagination || manualPagination;
    const isBackgroundFetching = deprecatedIsBackgroundFetching !== null && deprecatedIsBackgroundFetching !== void 0 ? deprecatedIsBackgroundFetching : instanceIsBackgroundFetching;
    const results = resultsSummary !== null && resultsSummary !== void 0 ? resultsSummary : (React.createElement(ConnectedResultsSummary, { isBackgroundFetching: isBackgroundFetching }));
    return (React.createElement(TableLayout, { dataMetrics: dataMetrics, dataTestId: dataTestId || "connected-table-layout", isBackgroundFetching: isBackgroundFetching, overflow: overflow, resultsSummary: results, paginator: paginationEnabled && paginator, ...rest }));
}

export { ConnectedTableLayout };
//# sourceMappingURL=ConnectedTableLayout.esm.js.map
